/* eslint-disable react-hooks/exhaustive-deps */
// TODO: Move these event listeners into a saga and pull the status from the store
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'

import NetworkIndicator from '../components/NetworkIndicator'
import { networkConnected, networkSignal } from '../utils/networkConnected'

const NetworkIndicatorWrapper = ({text}) => {
  const [available, setAvailable] = useState(true)
  const [speed, setSpeed] = useState(0)
  const pingRef = useRef()

  const startPinging = () => {
    stopPinging()
    const ping = () => networkConnected().then(() => setAvailable(true)).catch(() => setAvailable(false)).then(() => networkSignal(setSpeed))

    ping()
    pingRef.current = setInterval(ping, 10000)
  }

  const stopPinging = () => {
    clearInterval(pingRef.current)
    pingRef.current = undefined
  }

  useEffect(() => {
    const updateAvailability = (event) => {
      const available = event.type === "online"

      if (available && !pingRef.current) startPinging()
      if (!available && pingRef.current) stopPinging()

      setAvailable(available)
    }

    if (navigator.onLine) {
      startPinging()
    } else {
      setAvailable(false)
    }

    window.addEventListener('offline', updateAvailability)
    window.addEventListener('online', updateAvailability)

    return () => {
      stopPinging()
      window.removeEventListener('online', updateAvailability)
      window.removeEventListener('offline', updateAvailability)
    }
  }, [])

  return <NetworkIndicator available={available} speed={speed} text={text} />
}

NetworkIndicatorWrapper.defaultProps = {
  text: "network"
}

NetworkIndicatorWrapper.propTypes = {
  text: PropTypes.string
}


export default NetworkIndicatorWrapper
